import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/location_new/chicago/upscale_back.webp";
import { Link } from "gatsby";

function Dynamichouston() {
  return (
    <section
      className="dynamic_houston p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundColor: "#FBFBFB",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../images/location_new/chicago/upscale_chicago.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={607}
              height={766}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Upscale your brand with Top Mobile App Developers in Chicago
            </h2>
            <p>
              We build apps for the future. From ready-made, customizable white
              labels for start-ups to full-scale enterprise products, our team
              of top mobile app developers in Chicago is up for creating the
              best, built-for-experience solutions
            </p>
            <p>
              With novel technologies and the most fine-tuned processes, our app
              development company in Chicago helps businesses plan and launch a
              customer-facing product that is compatible across platforms,
              scalability-ready, and engages as your customers like to.
            </p>
            <p>
              Our mobile app development service in Chicago gets you
              collaborative enhancements for maximum output, automated testing
              frameworks for quality results, and zero downtime for quicker
              time-to-market – making us your ideal mobile app development
              company in Chicago.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Dynamichouston;
